var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquareCheck = function SvgSquareCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M16.496 7.095a9.32 9.32 0 0 1 9.302 9.302v5.897h.31a4.904 4.904 0 0 0 4.89-4.904V6.784a4.89 4.89 0 0 0-4.888-4.888H15.502a4.905 4.905 0 0 0-4.904 4.889v.31zm-6.898 1V6.783A5.904 5.904 0 0 1 15.502.895H26.11a5.89 5.89 0 0 1 5.888 5.888V17.39a5.904 5.904 0 0 1-5.888 5.904h-1.312v-6.896a8.32 8.32 0 0 0-8.304-8.303z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M17.345 17.845a1.2 1.2 0 0 0-1.696 0l-5.073 4.896-1.984-1.952a1.2 1.2 0 0 0-1.712 1.6l2.816 2.896a1.216 1.216 0 0 0 1.696 0l5.92-5.712a1.2 1.2 0 0 0 .033-1.728M12.09 26l-.002.002A2.216 2.216 0 0 1 9 26.001l-.01-.01-2.909-2.99-.06-.104a2.2 2.2 0 0 1 3.138-2.933l.073.05 1.352 1.33 4.366-4.214A2.2 2.2 0 1 1 18 20.298zm-6.202-15.26A5.904 5.904 0 0 0 0 16.645v10.608a5.89 5.89 0 0 0 5.888 5.888h10.609a5.904 5.904 0 0 0 5.904-5.888V16.645a5.904 5.904 0 0 0-5.904-5.904zm10.609 1H5.89A4.904 4.904 0 0 0 1 16.645v10.608a4.89 4.89 0 0 0 4.888 4.888h10.609a4.905 4.905 0 0 0 4.904-4.89V16.645a4.904 4.904 0 0 0-4.904-4.904",
    clipRule: "evenodd"
  })));
};
export default SvgSquareCheck;